import { makeObservable, observable, reaction } from "mobx"
import { cloneDeep } from 'lodash';
import { getMscByDomainKey } from 'ynf-core-engine/request';
import { loadFileResources } from "../../utils";

interface FileQuery {
  objectId: String,
  objectName?: String,
  tempObjectId?: String,
}

export default class FilesHandle {
  pageStore: any
  fileStore: any = {};
  fileObj: {
    [key: string]: any
  } = {}
  deleteFiles: Array<String>;
  authId: string
  batchFilesTableName: any = [];
  batchFilesArr: Array<String>
  queryFilesTimes: number
  copyFile: number
  copyFilelist: Array<any>;
  copyMap: any = {}
  batchFilesTableNames: any = {};
  query: any = {};
  currentTime: number

  constructor(pageStore?: any) {
    this.pageStore = pageStore
    const { query, history } = pageStore;
    const historyParams = history?.getHistoryParams?.() || {};
    this.query = Object.assign(this.query, query, historyParams.query)
    this.deleteFiles = [];
    this.authId = query?.serviceCode || "ybbase";
    this.batchFilesTableName = [];
    this.batchFilesArr = [];
    this.queryFilesTimes = 0;
    this.fileStore = {};
    this.copyFile = 0;
    this.copyMap = {};
    this.copyFilelist = [];
    this.currentTime = new Date().getTime();

    makeObservable(this, {
      queryFilesTimes: observable,
      fileObj: observable,
      deleteFiles: observable,
      copyFile: observable,
      copyFilelist: observable
    })

    // 复制
    reaction(() => this.copyFilelist, () => {
      this.copyFilelist.forEach(item => {
        const { targetObjectId } = item;
        this.copyMap[targetObjectId] = true;
      });
      this.copyAllFiles(this.copyFilelist || []);
    })


    // 处理action
    this.setAfterSaveHook();
    this.afterCopyHook();
  }

  // 挂载保存后事件
  setAfterSaveHook() {
    if (this.pageStore && typeof this.pageStore.rootStore === 'object') {
      const { actions = {} } = this.pageStore.rootStore;
      Object.entries(actions).forEach(([key, actionStore = {}]) => {
        if (actionStore.controlType === 'save') {
          actionStore.mixin?.({
            afterSaveHook : async () => {
              await this.bindFile();
            }
          })
        }
      })
    }
  }

  // 复制后事件
  afterCopyHook() {
    if (this.pageStore && typeof this.pageStore.rootStore === 'object') { 
      const { actions = {} } = this.pageStore.rootStore;
      Object.entries(actions).forEach(([key, actionStore = {}]) => {
        if (actionStore.controlType === 'copy') {
          actionStore.mixin?.({
            afterCopyHook : (...data: any []) => {
              this.copyFilelist = data?.[2] || [];
            }
          })
        }
      })
    }
  }

  // 初始化table的afterSetValue事件
  initTableEvents ({ name }: any) {
    const tableStore = this.pageStore?.rootStore[name];
    this.batchFilesTableName.push(name);
    if (tableStore) {
      this.formatBatchFiles({ name })
      tableStore.setHooks('afterSetValue', () => {
        this.formatBatchFiles({ name })
      })
    }
  }

  setCurrentTime () {
    this.currentTime = new Date().getTime();
  }

  clearFileStore () {
    this.fileStore = {};
  }

  setFileObj (obj: FileQuery) {
    const { objectId, tempObjectId } = obj;
    for (const key in this.fileObj) {
      if (tempObjectId === this.fileObj[key]?.tempObjectId) {
        delete this.fileObj[key]
      }
    }
    this.fileObj[String(objectId)] = obj;
  }
  
  getFileObj () {
    return cloneDeep(this.fileObj)
  }
  
  clearFileObj () {
    this.fileObj = {}
  }

  setDeleteFiles (id: string) {
    this.deleteFiles.push(id)
  }

  getDeleteFiles () {
    return cloneDeep(this.deleteFiles)
  }

  // modeChange 清空附件删除状态
  clearDeleteFiles () {
    this.deleteFiles = []
  }

   // 保存后绑定附件
  bindFile () {
    return new Promise<void>((resolve) => {
      const fileObj = this.getFileObj();
      const fileStore = this.fileStore || {};
      const bindList = [];
      const deletList = this.getDeleteFiles();
      let count = 0;
      let resultCount = 0;
      for (const key in fileObj) {
        const { objectId, tempObjectId, objectName } = fileObj[key] || {};
        const realArr: any = [];
        const fileKey = `${objectId}_${objectName}`;
        // 找出fileStore里这个key下面所有的objectId, tempObjectId在组件变化的时候会变化
        (fileStore[fileKey] || []).forEach((item: any) => {
          const { attributes = {}, ctime } = item;
          const { businessId } = attributes;
          if (businessId !== objectId && ctime > this.currentTime) {
            realArr.push(businessId);
            bindList.push({
              objectId,
              oldObjectId: businessId,
              bussinessType: objectName
            });
          }
        })
        if (objectId && tempObjectId && objectName && !realArr.includes(tempObjectId)) {
          const obj = {
            objectId,
            oldObjectId: tempObjectId,
            bussinessType: objectName
          }
          if (objectId !== tempObjectId) {
            bindList.push(obj);
          }
        }
      }
      if (deletList?.length) {
        count++
      }
      if (bindList.length) {
        count++
      }
      const callback = () => {
        resultCount++;
        if (resultCount === count && resolve) {
          this.clearDeleteFiles();
          this.clearFileObj();
          resolve();
        }
      }
      if (deletList.length) {
        window?.YYCooperationBridge?.YYFormFilesTempStateDelV2({
          deleteParams: {
            fileIds: deletList,
          },
          callback,
          extraParams: {
            authId: this.authId
          }
        });
      }
      if (bindList.length) {
        window?.YYCooperationBridge?.YYUploadedFilesBindV2({
          bindList,
          callback,
          extraParams: {
            authId: this.authId
          }
        });
      }
      if (!count) {
        resolve();
      }
    });
  }

  // 原始批量请求
  queryAllFiles (searchList: any) {
    const newlist: any = [];
    searchList.forEach((item: any) => {
      const { objectId } = item;
      if (!this.copyMap[objectId]) {
        newlist.push(item)
      }
    });
    if (!newlist?.length) {
      return new Promise((resolve) => {
        resolve([]);
      })
    }
    let result;
    if (window?.YYCooperationBridge?.YYFormFileGetAllListByObjectIdV2) {
      result = window?.YYCooperationBridge?.YYFormFileGetAllListByObjectIdV2({
        searchList: newlist,
        extraParams: {
          authId: this.authId
        }
      })
    } else {
      result = window?.YYCooperationBridge?.YYFormFileGetAllListByObjectId(searchList, false, undefined, undefined, this.authId);
    }
    return result;
  }

  // 批量请求附件
  queryBatchFiles (list: Array<any>, columns: any) {
    loadFileResources(() => {
      const searchList: Array<any> = [];
      const obj: any = {};
      for (const key of columns?.keys?.()) {
        const item = columns.get(key);
        const controlTypes = ['image', 'attachment']
        const controlTypes1 = ['upload', 'pictureupload']
        if (controlTypes.includes(item.bizType?.toLocaleLowerCase()) || controlTypes1.includes(item.controlType?.toLocaleLowerCase())) {
          obj[key] = {
            objectName: item?.fieldDesc?.objectName || item?.fieldDesc?.defaultObjectName || item?.fieldDesc?.domainKey
          }
        }
      }
      const newObj:any = {};
      list.forEach((data: any) => {
        const item = data.getValue();
        for (const key in obj) {
          let objectName = obj[key].objectName || getMscByDomainKey?.(this?.query?.domainKey) || this?.query?.domainKey || 'developplatform'
          if (!obj[key].objectName && objectName === 'developplatform' && this?.query?.domainKey === 'developplatform') {
            objectName = 'iuap-yonbuilder-runtime'
          }
          if (item[key]) {
            const k = `${item[key]}_${objectName}`;
            newObj[k] = [];
            searchList.push({
              objectId: item[key],
              objectName
            })
          }
        }
      });
      Object.assign(this.fileStore, newObj);
      console.log('---searchList-', searchList)
      if (!searchList?.length) return;
      const result = this.queryAllFiles(searchList);
      result.then((data: any) => {
        console.log('data', data);
        if (Array.isArray(data)) {
          const obj: any = {};
          data.forEach((element) => {
            const { objectId, objectName } = element;
            const key = `${objectId}_${objectName}`;
            if (obj[key]) {
              obj[key].push(element)
            } else {
              obj[key] = [element];
            }
          });
          Object.assign(this.fileStore, obj);
          this.queryFilesTimes = new Date().getTime();
        }
      })
    }, this.pageStore.rootStore.isMobile);
  }

  pushBatchFilesInFileStore (key: any, list: any) {
    this.fileStore[key] = [];
    list.forEach((element: any) => {
      const objectId = element.objectId;
      const objectName = element.objectName;
      const key = `${objectId}_${objectName}`;
      if (this.fileStore[key]) {
        this.fileStore[key].push(element);
      } else {
        this.fileStore[key] = [element];
      }
      this.queryFilesTimes = new Date().getTime();
    });
  }

  // 上传后添加
  pushFilesInFileStore (fileJson: any) {
    const objectId = fileJson.objectId;
    const objectName = fileJson.objectName;
    const key = `${objectId}_${objectName}`;
    if (this.fileStore[key]) {
      this.fileStore[key].push(fileJson);
    } else {
      this.fileStore[key] = [fileJson];
    }
    this.queryFilesTimes = new Date().getTime();
  }

  // 删除
  deleteFilesInFileStore (fileJson: any, fid: String) {
    const objectId = fileJson.objectId;
    const objectName = fileJson.objectName;
    const key = `${objectId}_${objectName}`;
    const list = this.fileStore[key] || [];
    const newList: any = [];
    list.forEach((element: any) => {
      if (element.id !== fid) {
        newList.push(element);
      }
    });
    this.fileStore[key] = newList;
    this.queryFilesTimes = new Date().getTime();
  }

  getAllFiles = () => {
    return this.fileStore;
  }

  formatBatchFiles = ({ name } : any) => {
    if (name) {
      clearTimeout(this.batchFilesTableNames[name]);
      this.batchFilesTableNames[name] = setTimeout(() => {
        const table = this.pageStore.rootStore?.[name];
        const data = table.data;
        const columns = table.columns;
        this.queryBatchFiles(data, columns);
      }, 100)
    }
  }
  // 复制附件
  copyAllFiles = (fileList: any) => {
    const batchFiles: any = [];
    const list = fileList.map((item: any) => {
      const {sourceObjectId, sourceObjectName, targetObjectId, targetObjectName, isTable} = item;
      if (isTable) {
        batchFiles.push({
          objectId: targetObjectId,
          objectName: targetObjectName
        })
      }
      return {
        sourceObjectId,
        sourceObjectName,
        targetObjectId,
        targetObjectName
      }
    })
    loadFileResources(() => {
      window.YYCooperationBridge.YYFormFilesCopyAllV2({
        copyList: list,
        extraParams: {
          authId: this.authId
        },
        callback: () => {
          this.copyMap = {};
            // copy完调files接口，查不回数据
          this.copyFile = new Date().getTime();
          if (!batchFiles?.length) return;
          this.queryAllFiles(batchFiles)?.then((data: any) => {
            if (Array.isArray(data)) {
              const obj: any = {};
              data.forEach((element) => {
                const { objectId, objectName } = element;
                const key = `${objectId}_${objectName}`;
                if (obj[key]) {
                  obj[key].push(element)
                } else {
                  obj[key] = [element];
                }
              });
              Object.assign(this.fileStore, obj);
              this.queryFilesTimes = new Date().getTime();
            }
          }).catch((err: any) => {
            console.log('-----err', err);
          })
        }
      })
    })
  }
}
